(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/init-momang-categories/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/components/casino-react/init-momang-categories/assets/javascripts/init.js');
"use strict";


const {
  render
} = ReactDOM;
const {
  useEffect
} = React;
const {
  RootMomang
} = svs.components.casino_react.pageCategoryGamesStandalone;
const {
  ErrorBoundary
} = svs.components.errorBoundary;
const {
  initialCategory,
  categories,
  isLiveCasino,
  basename
} = svs.momang_casino_categories.data.renderModel;
const App = () => {
  useEffect(() => {
    svs.components.casino.animateHeader.init();
  }, []);
  return React.createElement(React.StrictMode, null, React.createElement(ErrorBoundary, null, React.createElement(RootMomang, {
    basename: basename,
    currentCategoryList: categories,
    initialCategory: initialCategory,
    isLiveCasino: isLiveCasino
  })));
};
const init = appRoot => {
  if (appRoot) {
    if (svs.core.detect.formfactor.mobile()) {
      if (svs.core.detect.feature('ft-floating-swish-buttons')) {
        new svs.casino.quick_transaction.TransactionButtons();
      }
    }
    render(React.createElement(App, null), appRoot);
  }
};
const appRoot = document.getElementById('casino-categories-page');
init(appRoot);
setGlobal('svs.components.casino_react.initMomang', {
  init,
  App
});

 })(window);